import {actions as A} from '../constants/actions';

export const setPage = page => dispatch => {
  dispatch({
    type: A.SET_INSPECTIONS_BY_SHARED_PAGE,
    payload: {page}
  });
};
